import { createStyles } from 'antd-style'

export const useStyles = createStyles(({ token }) => ({
  textarea: {
    maxHeight: 220
  },
  permissionWrapper: {
    padding: 16,
    width: '100%',
    maxHeight: 230,
    overflow: 'auto'
  },
  tags: {
    borderRadius: 16,
    padding: '4px 10px 4px 12px',
    color: token.primary.primary1,
    backgroundColor: token.blue1,
    border: 'none',
    '.ant-tag-close-icon': {
      color: token.primary.primary1
    }
  },
  placeholder: {
    paddingLeft: 8,
    color: token.colorTextPlaceholder
  },
  permissionsModuleCollapse: {
    paddingLeft: 16,
    background: token.colorBgContainer,
    borderRadius: 6
  },
  permissionsDomainCollapse: {
    padding: '8px 0 8px 16px'
  },
  domainFontSize: {
    fontSize: '13px !important'
  },
  permissionList: {
    paddingLeft: 16,
    paddingTop: 8
  },
  permissionCheckbox: {
    paddingLeft: 16
  },
  moduleCollapseWrapper: {
    marginBottom: 12
  }
}))
